import { Pipe, PipeTransform } from '@angular/core';
import { Ocorrencia } from '../../modelos/ocorrencia';

@Pipe({
  name: 'filtroOcorrenciaPontoFisico',
  pure: false
})
export class FiltroOcorrenciaPontoFisicoPipe implements PipeTransform {

  transform(ocorrencias: Ocorrencia[], filtro?: string): any {
    if (ocorrencias === undefined || filtro === undefined || filtro.trim() === '') {
      return ocorrencias;
    }
    filtro = filtro.toLocaleLowerCase();
    return ocorrencias.filter(ocorrencia => ocorrencia.pontoFisico.nomePontoFisico.toLocaleLowerCase().indexOf(filtro) >= 0);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-ocorrencia-ponto-fisico.pipe.ts